import { h, Fragment } from "preact";
import { Typography, Button, Box, TextField, Stack } from "@mui/material";
import { useState, useEffect, useContext } from "preact/hooks";
import { ValidatePwd } from "../Common/helpers";

import { AppContext } from "../../AppContext";
export default function Pwd({ }) {
    const [complete, setComplete] = useState(false);
    const app = useContext(AppContext);

    const [formData, setFormData] = useState({});
    const handleChange = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.value });
    };

    useEffect(() => {
        console.log("ValidatePwd(formData.pwd1)", ValidatePwd(formData.pwd1))
        if (
            formData.pwd0 !== "" &&
            ValidatePwd(formData.pwd1).res &&
            formData.pwd1 === formData.pwd2
        ) {
            setComplete(true);
        } else {
            setComplete(false);
        }
    }, [formData]);
    const submitPwd = () => {
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ pwd0: formData.pwd0, pwd1: formData.pwd1, pwd2: formData.pwd2 })
        };
        fetch("/api/18719993b2f047549dbf8c575a859218/", requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":
                        console.log(res.pld)

                        window.location.href = "/login";

                        break;
                    case "err":
                        break;
                    default:
                        break;
                }
            });
    }
    return (
        <div style="padding-top: 10px; padding-bottom: 10px; max-width: 400px;">
            <Stack spacing={1}>
                <TextField
                    id="pwd0"
                    name="pwd0"
                    variant="outlined"
                    style={{
                        marginLeft: 0,
                        marginRight: 10,
                    }}
                    placeholder="Mot de passe actuel"
                    fullWidth
                    margin="dense"
                    size="small"
                    value={formData.pwd0}
                    onChange={handleChange}
                    type="password"
                />

                <TextField
                    id="pwd1"
                    name="pwd1"
                    variant="outlined"
                    style={{
                        marginLeft: 0,
                        marginRight: 10,
                    }}
                    placeholder="Nouveau mot de passe (6 caractères min)"
                    fullWidth
                    margin="dense"
                    size="small"
                    value={formData.pwd1}
                    onChange={handleChange}
                    type="password"
                />

                <TextField
                    id="pwd2"
                    name="pwd2"
                    variant="outlined"
                    style={{
                        marginLeft: 0,
                        marginRight: 10,
                    }}
                    placeholder="Confirmation du nouveau mot de passe"
                    fullWidth
                    margin="dense"
                    size="small"
                    value={formData.pwd2}
                    onChange={handleChange}
                    type="password"
                />

                <Box display="flex" justifyContent="flex-end" alignItems="center" >
                    <Box>
                        <Button
                            variant="contained"
                            disabled={!complete}
                            onClick={() => {
                                submitPwd()
                            }}

                        >
                            Valider le nouveau mot de passe
                        </Button>
                    </Box>
                </Box>
            </Stack>
        </div>
    );
}
